<template>
	<div class="kxzydhszc-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{ youshiInfo.title || '' }}</div>
				<div class="des">助力集装箱产品碳足迹“算得出”“算得准”</div>
				<!-- 				<div class="des">{{youshiInfo.des || ''}}</div> -->
			</div>
		</div>
		<div class="kxzydhszc-page-content">
			<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
				<div class="container section">
					<h2 class="section-title">权威数据库覆盖</h2>
					<p class="section-subtitle">融合全球与本土数据资源，打破单一行业限制</p>
	
					<div class="db-grid">
						<div class="db-card">
							<div class="icon-box"><i class="fas fa-globe-americas"></i></div>
							<h3>Ecoinvent 数据库</h3>
							<p>全球知名的生命周期（LCA）评估数据库，覆盖从原材料生产到产品回收的全生命周期，是国际通用的数据基准。</p>
						</div>
						<div class="db-card">
							<div class="icon-box"><i class="fas fa-map-marked-alt"></i></div>
							<h3>HiQLCD 本土数据库</h3>
							<p>基于 ISO 14044、ISO/TS 14071 等多项国际方法学，提供符合中国本土环境影响的高质量数据支持。</p>
						</div>
						<div class="db-card">
							<div class="icon-box"><i class="fas fa-ship"></i></div>
							<h3>集装箱行业数据库</h3>
							<p>由中国集装箱行业协会启动建设，结合企业实际，旨在构建更贴近行业生产实际的专属碳因子库。</p>
						</div>
					</div>
				</div>
			</div>
			<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
				<div class="container section">
					<h2 class="section-title">跨领域应用场景</h2>
					<p class="section-subtitle">满足LCA计算、供应链评估、合规性申报等多种需求</p>
	
					<div class="scenario-list">
						<div class="scenario-item">
							<div class="sc-number">01.</div>
							<div class="sc-content">
								<h3>绿色供应链与生态设计</h3>
								<!-- <p>能源 - 化工 - 电子 - 装备制造全链条</p> -->
							</div>
							<div class="sc-value">
								<div class="orange-line"></div>
								<p>帮助核心企业筛选低碳供应商，优化资源利用，制定科学减排措施，实现供应链协同降碳。</p>
							</div>
						</div>
	
						<div class="scenario-item">
							<div class="sc-number">02.</div>
							<div class="sc-content">
								<h3>国际市场准入</h3>
								<!-- <p>电子电器、机械装备、出口导向型行业</p> -->
							</div>
							<div class="sc-value">
								<div class="orange-line"></div>
								<p>获取符合国际标准（如欧盟CBAM）的产品碳足迹认证，降低贸易壁垒，提升产品在海外市场的竞争力。</p>
							</div>
						</div>
	
						<div class="scenario-item">
							<div class="sc-number">03.</div>
							<div class="sc-content">
								<h3>政策合规与标准认证</h3>
								<!-- <p>基于 ISO 14044, ILCD Handbook, EN15804 标准</p> -->
							</div>
							<div class="sc-value">
								<div class="orange-line"></div>
								<p>直接满足国内外碳交易、碳披露等政策申报需求，确保LCA评估结果的权威性与互认性。</p>
							</div>
						</div>
	
						<div class="scenario-item">
							<div class="sc-number">04.</div>
							<div class="sc-content">
								<h3>绿色消费与品牌价值</h3>
								<!-- <p>食品饮料、家电、服装等消费品行业</p> -->
							</div>
							<div class="sc-value">
								<div class="orange-line"></div>
								<p>通过碳标签展示产品环保属性，提升品牌形象，满足消费者日益增长的绿色消费需求。</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
				<div class="bottom-bg">
					<div class="container">
						<h2 class="section-title" style="margin-bottom: 40px">行业数据库建设战略价值</h2>
	
						<div class="strategy-flex">
							<div class="strategy-text">
								<div class="feature-item">
									<div class="feature-icon"><i class="fas fa-file-contract"></i></div>
									<div class="feature-desc">
										<h4>数据库建设正式启动</h4>
										<p>中国集装箱行业协会已启动行业LCA碳足迹数据库建设，填补行业数据空白。</p>
									</div>
								</div>
								<div class="feature-item">
									<div class="feature-icon"><i class="fas fa-ruler-combined"></i></div>
									<div class="feature-desc">
										<h4>遵循国际规则</h4>
										<p>数据库建设严格基于国际 ILCD handbook 等相关规则，确保数据的科学性与通用性。</p>
									</div>
								</div>
								<div class="feature-item">
									<div class="feature-icon"><i class="fas fa-industry"></i></div>
									<div class="feature-desc">
										<h4>贴近行业实际</h4>
										<p>结合集装箱生产企业实际工艺数据，构建真实的行业碳因子，避免通用数据带来的误差。</p>
									</div>
								</div>
							</div>
	
							<div class="strategy-img">
								<img class="img" src="@/assets/tmp/044.png" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 权威标准体系支撑 -->
		<!-- <div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-1">
				<div class="section-container w1260">
					<div class="heading">权威标准体系支撑</div>
					<div class="des">平台严格遵循 "国家标准 + 国际标准" 双轨制核算体系，确保核算结果的权威性和国际认可度</div>
					<div class="ul">
						<div class="li">
							<div class="label">国家标准</div>
							<div class="li-des">明确了集装箱产品碳足迹核算的边界、方法、数据质量要求和报告格式</div>
							<div class="line"></div>
						</div>
						<div class="li">
							<div class="label">国际标准</div>
							<div class="li-des">确保核算结果符合国际通行规则</div>
							<div class="line"></div>
						</div>
						<div class="li">
							<div class="label">行业规范</div>
							<div class="li-des">为产品全生命周期碳排放核算提供系统性框架</div>
							<div class="line"></div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- 中国集装箱行业绿色低碳公共服务平台 -->
		<!-- <div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-2">
				<div class="section-container w1260">
					<div class="left-block scale-img">
						<img class="img" src="@/assets/tmp/042.png" alt="" />
					</div>
					<div class="right-block">
						<div class="heading">中国集装箱行业绿色低碳公共服务平台</div>
						<div class="des">通过标准引领、数据支撑、技术赋能、验证保障四位一体的科学核算体系，为集装箱企业提供了精准、高效、可信的碳足迹核算服务。这不仅是企业应对全球碳挑战的合规工具，更是推动行业绿色转型的科学引擎，为中国集装箱产业参与全球气候治理提供了强有力的技术支撑。</div>
						<div class="ul">
							<div class="li">
								<div class="serial">1</div>
								<div class="content">
									<div class="label">碳排因子库</div>
									<div class="value">集成国内外权威排放因子数据库包含电力、热力、燃料等500 + 种能源和原材料的排放因子</div>
								</div>
							</div>
							<div class="li">
								<div class="serial">2</div>
								<div class="content">
									<div class="label">产品碳足迹库</div>
									<div class="value">收录 100 + 种标准集装箱型号的详细参数，建立产品与排放的映射关系</div>
								</div>
							</div>
							<div class="li">
								<div class="serial">3</div>
								<div class="content">
									<div class="label">设备能效标准库</div>
									<div class="value">包含开卷、冲压、焊接、涂装等关键工序的设备能耗标准，精确到单台设备小时能耗</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<Foot></Foot>
	</div>
</template>

<script>
import { webInfo } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
export default {
	name: 'kxzydhszc',
	components: { Head, Foot },
	data() {
		return {
			youshiInfo: webInfo.pingtaiyoushi[2]
		};
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		}
	}
};
</script>

<style lang="scss" scoped>
.kxzydhszc-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		// background-image: url('~@/assets/tmp/027.png');
		background-size: cover;
		height: 233px;
		background-color: #29965c;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			padding-right: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 87px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
				text-align: center;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
				text-align: center;
			}
		}
	}

	.section-1 {
		background: #ffffff;
		padding-top: 63px;
		padding-bottom: 53px;
		.section-container {
			display: flex;
			flex-direction: column;
			.heading {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 34px;
				color: #000000;
				line-height: 52px;
			}
			.des {
				margin-top: 25px;
				width: 560px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 17px;
				color: #262729;
				line-height: 24px;
			}
			.ul {
				margin-top: 50px;
				display: flex;
				justify-content: space-between;
				.li {
					width: 355px;
					padding-top: 58px;
					min-height: 240px;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					position: relative;
					.label {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 30px;
						color: #262729;
						line-height: 42px;
					}
					.li-des {
						margin: 40px 0;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 17px;
						color: rgba(#262729, 0.7);
						line-height: 24px;
					}
					.line {
						position: absolute;
						z-index: 1;
						bottom: 0;
						left: 0;
						width: 250px;
						height: 4px;
						// background: #29965C;
						background: rgba(#1d263a, 0.1);
					}
				}
			}
		}
	}

	.section-2 {
		background: #ffffff;
		padding-top: 53px;
		padding-bottom: 63px;
		.section-container {
			display: flex;
			.left-block {
				// display: flex;
				img {
					width: 466px;
					height: 683px;
				}
			}
			.right-block {
				flex: 1;
				padding-left: 119px;
				padding-right: 10px;
				padding-top: 40px;
				.heading {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 30px;
					color: #262729;
					line-height: 42px;
				}
				.des {
					margin-top: 32px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 17px;
					color: rgba(#262729, 0.7);
					line-height: 24px;
				}
				.ul {
					margin-top: 38px;
					display: flex;
					flex-direction: column;
					.li {
						margin-top: 40px;
						display: flex;
						.serial {
							margin-top: 7px;
							width: 40px;
							height: 40px;
							background: #29965c;
							border-radius: 50%;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 23px;
							color: #ffffff;
							line-height: 40px;
							text-align: center;
						}
						.content {
							flex: 1;
							padding-left: 23px;
							display: flex;
							flex-direction: column;
							.label {
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 21px;
								color: #262729;
								line-height: 29px;
							}
							.value {
								margin-top: 8px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 15px;
								color: rgba(#262729, 0.7);
								line-height: 21px;
							}
						}
					}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
/* --- 基础重置 --- */
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	// font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
	color: #333;
	background-color: #fff;
	// line-height: 1.6;
}

.kxzydhszc-page-content {
	/* --- 通用样式工具 --- */
	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.section {
		padding: 60px 0;
	}

	.section-title {
		font-size: 28px;
		font-weight: bold;
		margin-bottom: 10px;
		color: #222;
	}

	.section-subtitle {
		font-size: 14px;
		color: #888;
		margin-bottom: 50px;
	}

	/* --- 顶部 Banner --- */
	.banner {
		background-color: #279056; /* 核心绿色 */
		color: #fff;
		padding: 80px 0;
		text-align: center;
	}

	.banner h1 {
		font-size: 36px;
		margin-bottom: 15px;
		font-weight: 600;
	}

	.banner p {
		font-size: 16px;
		opacity: 0.9;
		max-width: 800px;
		margin: 0 auto;
	}

	/* --- 卡片区域 (数据库介绍) --- */
	.db-grid {
		display: flex;
		gap: 20px;
		justify-content: space-between;
	}

	.db-card {
		flex: 1;
		background-color: #f5fcf7; /* 浅绿背景 */
		padding: 30px;
		border-radius: 4px;
		transition: transform 0.3s, box-shadow 0.3s;
	}

	.db-card:hover {
		transform: translateY(-5px);
		background-color: #279056;
		color: #fff;
		box-shadow: 0 10px 20px rgba(39, 144, 86, 0.2);
	}

	.db-card:hover h3,
	.db-card:hover p,
	.db-card:hover .icon-box {
		color: #fff;
	}

	.db-card .icon-box {
		font-size: 40px;
		color: #279056;
		margin-bottom: 20px;
	}

	.db-card h3 {
		font-size: 20px;
		margin-bottom: 15px;
		font-weight: 600;
	}

	.db-card p {
		font-size: 14px;
		color: #666;
		line-height: 1.6;
	}

	/* --- 列表区域 (应用场景) --- */
	.scenario-list {
		border-top: 1px solid #eee;
	}

	.scenario-item {
		display: flex;
		align-items: center;
		padding: 35px 0;
		border-bottom: 1px solid #eee;
	}

	.sc-number {
		font-size: 32px;
		color: #279056;
		font-weight: bold;
		width: 80px;
		flex-shrink: 0;
	}

	.sc-content {
		flex: 1;
		padding-right: 40px;
	}

	.sc-content h3 {
		font-size: 18px;
		// margin-bottom: 8px;
		color: #333;
	}

	.sc-content p {
		font-size: 14px;
		color: #888;
	}

	.sc-value {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.orange-line {
		width: 30px;
		height: 3px;
		background-color: #f69d62; /* 图片中的橙色线条 */
		margin-right: 15px;
		flex-shrink: 0;
	}

	.sc-value p {
		font-size: 14px;
		color: #555;
		line-height: 1.5;
	}

	/* --- 底部区域 (战略价值) --- */
	.bottom-bg {
		background-color: #f9fbf9;
		padding: 80px 0;
		margin-top: 40px;
	}

	.strategy-flex {
		display: flex;
		align-items: center;
		gap: 50px;
	}

	.strategy-text {
		flex: 1;
	}

	.strategy-img {
		flex: 1;
	}

	.strategy-img img {
		width: 100%;
		border-radius: 4px;
		box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
	}

	.feature-item {
		display: flex;
		margin-bottom: 30px;
	}

	.feature-icon {
		width: 50px;
		height: 50px;
		background-color: #e3f1e9;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #279056;
		font-size: 20px;
		margin-right: 20px;
		flex-shrink: 0;
	}

	.feature-desc h4 {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.feature-desc p {
		font-size: 13px;
		color: #666;
		line-height: 1.5;
	}

	/* --- 移动端适配 --- */
	@media (max-width: 768px) {
		.db-grid {
			flex-direction: column;
		}
		.scenario-item {
			flex-direction: column;
		}
		.sc-content {
			margin-bottom: 15px;
		}
		.strategy-flex {
			flex-direction: column;
		}
		.sc-number {
			font-size: 24px;
			margin-bottom: 10px;
		}
	}
}
</style>
